'use client'

import { ControlProvider } from '@/context/ControlContext'
import { NavigationProvider } from '@/context/NavigationContext'
import dynamic from 'next/dynamic'
import type { ReactNode } from 'react'
import { AudioProvider } from './AudioContext'
import { ChapterProvider } from './ChapterContext'
import { SubtitleProvider } from './SubtitleContext'
import { UserPrefsProvider } from './UserPrefsContext'
import { VideoProvider } from './VideoContext'

// Dynamically import client-side components to avoid SSR issues
const VideoPreloader = dynamic(
  () => import('@/components/VideoPreloader').then((mod) => ({ default: mod.VideoPreloader })),
  { ssr: false }
)
const ImagePreloader = dynamic(
  () => import('@/components/ImagePreloader').then((mod) => ({ default: mod.ImagePreloader })),
  { ssr: false }
)
const DevServiceWorkerKiller = dynamic(
  () => import('@/components/DevServiceWorkerKiller').then((mod) => ({ default: mod.DevServiceWorkerKiller })),
  { ssr: false }
)

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <NavigationProvider>
      <UserPrefsProvider>
        <VideoProvider>
          <AudioProvider>
            <SubtitleProvider>
              <ControlProvider>
                <ChapterProvider>
                  {children}

                  {/* Client-side only components */}
                  {process.env.NODE_ENV === 'development' && <DevServiceWorkerKiller />}
                  <VideoPreloader />
                  <ImagePreloader />
                </ChapterProvider>
              </ControlProvider>
            </SubtitleProvider>
          </AudioProvider>
        </VideoProvider>
      </UserPrefsProvider>
    </NavigationProvider>
  )
}
